import styled from '@emotion/styled';
import type { Props } from './AutoSwiper';

type StyleProps = Pick<Props, 'height' | 'itemGap' | 'animation'>;

export const ScrollerInner = styled.ul<{
  itemGap: StyleProps['itemGap'],
  height: StyleProps['height'],
  direction: StyleProps['animation']['direction'],
}>`
  --item-gap: ${({ itemGap }) => itemGap || 20}px;

  display: flex;
  width: max-content;
  height: ${(props) => props.height}px;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0;
  margin: 0;
  gap: ${(props) => props.itemGap}px;
  list-style: none;
`;

export const Scroller = styled.div<Omit<StyleProps, 'height'>>`
  --item-gap: ${({ itemGap }) => itemGap || 20}px;

  width: 100%;
  overflow-x: auto;

  &[data-animated='true'] {
    overflow: hidden;

    #scroller-inner {
      animation-delay: ${({ animation }) => animation.delay || 0.3}s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: ${({ animation }) => animation.direction || 'left'};
      animation-timing-function: linear;
    }


    @keyframes left {
      to {
        transform: translate(calc(-50% - calc(var(--item-gap) / 2))) translate3d(0px, 0px, 0px);
      }
    }

    @keyframes right {
      to {
        transform: translate(calc(50% + calc(var(--item-gap) / 2))) translate3d(0px, 0px, 0px);
      }
    }
  }
`;
